export const roleConstants = {
  GET_ALL_REQUEST: "GET_ALL_ROLE_REQUEST",
  GET_ALL_SUCCESS: "GET_ALL_ROLE_SUCCESS",
  GET_ALL_FAILURE: "GET_ALL_ROLE_FAILURE",

  GET_BYID_REQUEST: "GET_BYID_ROLE_REQUEST",
  GET_BYID_SUCCESS: "GET_BYID_ROLE_SUCCESS",
  GET_BYID_FAILURE: "GET_BYID_ROLE_FAILURE",

  CREATE_REQUEST: "CREATE_ROLE_REQUEST",
  CREATE_SUCCESS: "CREATE_ROLE_SUCCESS",
  CREATE_FAILURE: "CREATE_ROLE_FAILURE",

  UPDATE_REQUEST: "UPDATE_ROLE_REQUEST",
  UPDATE_SUCCESS: "UPDATE_ROLE_SUCCESS",
  UPDATE_FAILURE: "UPDATE_ROLE_FAILURE",

  DELETE_REQUEST: "DELETE_ROLE_REQUEST",
  DELETE_SUCCESS: "DELETE_ROLE_SUCCESS",
  DELETE_FAILURE: "DELETE_ROLE_FAILURE",
};
